import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-company-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './company-card.component.html',
  styleUrl: './company-card.component.css',
})
export class CompanyCardComponent {
  @Input() item: any;
  // readMore: { [key: number]: boolean } = {};

  formatString(value: string) {
    return value.length > 100 ? value.substring(0, 150) + '...' : value;
  }

  // handleReadMore(index: number) {
  //   this.readMore[index] = !this.readMore[index];
  // }
}
